import React from "react";
import Reveal from "../common/Reveal";

const FeatureSection = () => {
  return (
    <div className="mx-auto max-w-7xl px-4 pt-20 text-center sm:px-6 lg:px-8">
      <Reveal>
        <span className="text-sm font-semibold uppercase tracking-wide text-accent-600">
          경영전략
        </span>
        <h2 className="mt-3 break-keep text-3xl font-bold text-primary-900 sm:text-4xl">
          데이터로 연결하고 AI로 혁신하는 스마트 제조
        </h2>
        <p className="mx-auto mt-4 max-w-2xl break-keep text-base leading-relaxed text-gray-600">
          MTST는 제조 현장의 데이터를 표준화·분석하여 생산성 향상, 품질 개선,
          비용 절감으로 이어지는 실질적인 제조 혁신을 지원합니다.
        </p>
      </Reveal>
    </div>
  );
};

export default FeatureSection;
